import React from 'react';
import s from './s.module.less';
import { TITLE } from './constants';
import Frame1 from './imgs/frame1.png';
import FrequencyQuestionSecion from 'components/FrequencyQuestionSecion';
import { TFaqInfo } from 'types/operation';
import Img1 from './imgs/faq1.png';
import Img2 from './imgs/faq2.png';
import Img3 from './imgs/faq3.png';
import { Email } from 'constants/contact';

//https://www.notion.so/klarityhealth/Klarity-E-Prescriptions-FAQ-29518650acdf80bdb42aeb850c7c4263?source=copy_link

// - Unlimited electronic prescriptions to over 95% of US pharmacies
// - EPCS certification for controlled substances (Schedule II-V)
// - PDMP (Prescription Drug Monitoring Program) integration
// - Real-time formulary checking and cost transparency
// - Drug interaction and allergy alerts
// - Prescription status tracking (sent, filled, denied)
// - Free software updates and security patches
// - Email and chat support during business hours
export const FAQData1: TFaqInfo[] = [
    {
        id: 1,
        pageId: 1,
        seq: 1,
        question: 'Q1. What is Klarity Pay Later?',
        answer: `
        Klarity Pay Later is Klarity’s financing program, powered by <a href="https://kanmon.com/">Kanmon</a>, that helps healthcare providers accelerate the growth of their practice. It offers short-term, low-fee advances to cover Klarity marketing services such as Prolisting and Standard Listings.
`,
    },
    {
        id: 2,
        pageId: 2,
        seq: 2,
        question: 'Q2. How does it work?',
        answer: `After you qualify for Klarity Pay Later, Kanmon will pay for your Prolisting and Standard Listings invoices. After you have the cash on-hand (i.e. getting reimbursed from insurance, getting paid by patient or obtaining the fund from other means), you’ll then pay back to Kanmon with a fee, which is lower than most credit card fees. Essentially, Kanmon covers your marketing investment today, and you repay the balance over time at a low monthly fee—starting as low as 1%, much lower than most credit cards. 
`,
    },
    {
        id: 3,
        pageId: 3,
        seq: 3,
        question: 'Q3. What can I use the funds for?',
        answer: `
        <div>Klarity Pay Later can be used <b>only for Klarity-related marketing services</b>, such as:</div>    
        <ul>
            <li>
                Prolisting - Klarity’s premium visibility program that places your profile at the top of patient search results, helping you attract more new patients and grow your practice faster.
            </li>
            <li>
               Standard listing, the standard “lead-generation” fee incurred for every new patient appointment in the “Pay-per-Appointment” model
            </li>
        </ul>
        <div>In the next few months, we’ll announce <b>Klarity Growth Capital</b>, which can cover broader growth activities, especially helping you to establish in-person visits, expanding to other states, and meeting compliance requirements. </div>
    `,
    },
];
// Q4. Who is eligible to apply?
// All listed Klarity providers in good standing—meaning they hold an active, verified license, have no unpaid invoices, and remain compliant with Klarity’s billing and platform policies—are pre-qualified for Klarity Pay Later. For group practices, the owner or an authorized representative can apply on behalf of the organization.
// Practices that have been operating for less than one year are also eligible, though approval depends on additional factors such as financial history and account standing.
// We accept sole proprietorships and personal accounts; however, business accounts (for LLCs, corporations, or partnerships) are preferred for smoother processing.
// Q5. Do I need to provide financial documents?
// No lengthy paperwork is required. We simply require the following:
// Detail about any existing debts
// Bank account statements (securely connect via Plaid or provide last 6 months manually)
// Business tax returns (last 2 years)
// Soft pull of your credit report.

// Q6. How are fees determined? And what are the variables?

// Loan eligibility is based on a variety of factors related to your business, including your outstanding debt balance, business expenses and income, account history, payment frequency, and more. To get started on your loan offer click here.
// You can complete the entire application process inside the Klarity Provider Portal. No in-person appointment is needed.

export const FAQData2: TFaqInfo[] = [
    {
        id: 4,
        pageId: 4,
        seq: 4,
        question: 'Q4. Who is eligible to apply?',
        answer: `
        <div>All listed Klarity providers in good standing—meaning they hold an active, verified license, have no unpaid invoices, and remain compliant with Klarity’s billing and platform policies—are pre-qualified for Klarity Pay Later. For group practices, the owner or an authorized representative can apply on behalf of the organization.</div> 
        <div>Practices that have been operating for less than one year are also eligible, though approval depends on additional factors such as financial history and account standing.</div>
        <div>We accept sole proprietorships and personal accounts; however, business accounts (for LLCs, corporations, or partnerships) are preferred for smoother processing.</div>
        `,
    },
    {
        id: 5,
        pageId: 5,
        seq: 5,
        question: 'Q5. Do I need to provide financial documents?',
        answer: `
        No lengthy paperwork is required. We simply require the following:
        <ul>
        <li>Detail about any existing debts</li>
        <li>Bank account statements (securely connect via Plaid or provide last 6 months manually)</li>
        <li>Business tax returns (last 2 years)</li>
        <li>Soft pull of your credit report.</li>
        </ul>
        `,
    },
    {
        id: 6,
        pageId: 6,
        seq: 6,
        question: 'Q6. How are fees determined? And what are the variables?',
        answer: `
        <div>Loan eligibility is based on a variety of factors related to your business, including your outstanding debt balance, business expenses and income, account history, payment frequency, and more. To get started on your loan offer click here.</div>
        <div>You can complete the entire application process inside the Klarity Provider Portal. No in-person appointment is needed. </div>
        `,
    },
    {
        id: 7,
        pageId: 7,
        seq: 7,
        question: 'Q7. How do I apply?',
        answerCompnent: (
            <div className="faq-wrap">
                <div>You can apply for Klarity Pay Later (powered by Kanmon) through any of the following locations in your <a href="http://provider.helloklarity.com" target="_blank" rel="noreferrer"> Klarity account</a>:</div>
                <div><b>Option 1 — From the Home Dashboard</b></div>
                <ul>
                    <li>Log in to your Klarity account.</li>
                    <li>Look for the green banner at the top that says <b>“You are pre-approved for Klarity Pay Later — up to $10K.”</b>
                    </li>
                    <li>Click See if you qualify → then select Apply now and complete the short qualification form.
                    </li>
                </ul>
                <div>
                    <img src={Img1} />
                </div>
                <br />
                <div><b>Option 2 — From Financial Settings</b></div>
                <ul>
                    <li>Go to <b>Financials</b> in your left-hand menu.</li>
                    <li>Click Settings (top right).</li>
                    <li>Under  <b>Payment method settings</b>, select <b>Switch to Klarity Pay Later</b>.
                    </li>
                    <li>You’ll be redirected to the Pay Later information page — click <b>Apply now</b> to begin your application.</li>
                </ul>
                <div>
                    <img src={Img2} />
                </div>
                <div><b>Option 3 — From an Invoice Page</b></div>
                <ul>
                    <li>GGo to <b>Financials</b> → then <b>Pro-Listings</b> or <b>Marketing Investment</b> tabs.</li>
                    <li>If you have an unpaid balance, you’ll see a <b>Pay Later</b> option next to your invoice.
                    </li>
                    <li>Click <b>Pay Later</b> → review the Klarity Pay Later page, then select <b>Apply now</b> to continue your application.</li>
                </ul>
                <div>
                    <img src={Img3} />
                </div>
                <div>If you need help navigating any of these steps, please contact <a href={`mailto:${Email.klarity_provider_support}`}>{Email.klarity_provider_support}</a> for assistance. </div>
            </div>
        ),
    },
    {
        id: 8,
        pageId: 8,
        seq: 8,
        question: 'Q8. What if I’m not approved? Can I reapply?',
        answer: `
        <div>
Yes. If you’re not approved, you can reapply at any time by contacting help@kanmon.com. Keep in mind that approval decisions are <b>based on Kanmon’s financing guidelines</b>, and it often takes some time for financial circumstances to change. If you’re initially denied, you may want to allow some time before reapplying.
        </div>
        `,
    },
];

// Q11. How is repayment collected?
// Repayment is automatically deducted from your linked bank accounts when you apply for the capital.  You can submit payment directly inside the Klarity provider portal.
// Q12. Can I repay early?
// Yes. You can repay anytime without penalty, and doing so helps expand your future credit line.
// Q13. Is this a loan or line of credit?
// It functions like a short-term working capital advance, purpose-built for Klarity marketing expenses. Your approved lending amount may increase as you consistently pay back on time.

export const FAQData3: TFaqInfo[] = [
    {
        id: 9,
        pageId: 9,
        seq: 9,
        question: 'Q9. What are the available capital amounts?',
        answer: `
        Each provider can apply for capital amounts ranging from <b>$500 to $10,000</b>, depending on your practice bank statement and credit history.
        `,
    },
    {
        id: 10,
        pageId: 10,
        seq: 10,
        question: 'Q10. What are the fees to be paid back?',
        answer: `
        <div><b>New Participant promotion: </b></div>
        <div>If you sign up before Dec 31st, 2025, you are qualified for the following promotional fee for at least 12 months</div>
        <ul>
            <li>
                <div><b>≤30-day repayment:</b>1.3%</div>
                <div>Example, if your invoice amount is $1,000, replay $1,013 within 30 days.</div>
            </li>
           <li>
                <div><b>30–60-day repayment:</b>3.0%</div>
                <div>Example, if your invoice amount is $1,000, replay $1,030 within 60 days. </div>
            </li>
            <li>
                <div><b>60-90-day repayment:</b>4.5%</div>
                <div>Example, if your invoice amount is $1,000, replay $1,045 within 90 days. </div>
            </li>
            <li><div>There are no hidden charges or prepayment penalties.</div></li>
        </ul>
        <div><b>Regular Fees</b></div>
        <div>Regular fees, which are still lower than most credit card fees, apply during non-promotional period:</div>
        <ul>
            <li>
                <div><b>≤30-day repayment:</b>2%</div>
                <div>Example, if your invoice amount is $1,000, replay $1,020 within 30 days.</div>
            </li>
           <li>
                <div><b>30–60-day repayment:</b>3.5%</div>
                <div>Example, if your invoice amount is $1,000, replay $1,035 within 60 days. </div>
            </li>
            <li>
                <div><b>60-90-day repayment:</b>5.0%</div>
                <div>Example, if your invoice amount is $1,000, replay $1,050 within 90 days. </div>
            </li>
            <li><div>There are no hidden charges or prepayment penalties.</div></li>
        </ul>
        <div class="table">
        <table>
            <colgroup>
                <col style="width: 200px;" />
                <col style="width: 200px;" />
                <col style="width: auto;" />
            </colgroup>
            <thead>
                <tr>
                    <th>Payback period</th>
                    <th>Monthly fee</th>
                    <th>New Participant Promo for practices signed before Dec 31st, 2025 (these pricing is valid for at least 12 months). </th>
                </tr>
            </thead>
            <tbody>
            <tr>
                <td><= 30 days</td>
                <td>2.0%</td>
                <td>1.3%</td>
            </tr>
            <tr>
                <td>30–60 days</td>
                <td>3.5%</td>
                <td>3.0%</td>
            </tr>
            <tr>
                <td>60–90 days</td>
                <td>5.0%</td>
                <td>4.5%</td>
            </tr>
        </tbody>
        </table>
        <div>*All capital and fees should be paid within 90 days of withdrawal. </div>
        </div>
        `,
    },
    {
        id: 11,
        pageId: 11,
        seq: 11,
        question: 'Q11. How is repayment collected?',
        answer: `
        Repayment is automatically deducted from your linked bank accounts when you apply for the capital.  You can submit payment directly inside the Klarity provider portal. 
        `,
    },
    {
        id: 12,
        pageId: 12,
        seq: 12,
        question: 'Q12. Can I repay early?',
        answer: `
        Yes. You can repay anytime without penalty, and doing so helps expand your future credit line.
        `,
    },
    {
        id: 13,
        pageId: 13,
        seq: 13,
        question: 'Q13. Is this a loan or line of credit?',
        answer: `
        It functions like a <b>short-term working capital advance</b>, purpose-built for Klarity marketing expenses. Your approved lending amount may increase as you consistently pay back on time.
        `,
    },
];

// Q14. Why is this better than using a credit card?
// Klarity Pay Later offers a flat fee as low as 1%, significantly lower than most credit card rates (~3%). It’s also automatically linked to your Klarity account, so no card processing or transfer delays.
// Q15. How fast can I access the funds?
// You have access to the funding as little as 24 hours from application approval. Once you accept the offer, your Klarity invoice is financed on the spot—no waiting, no separate disbursement.
// Q16. Will using this affect my credit score?
// Kanmon will perform a soft credit check. This check will not affect your credit score.
// Q17. Can group practices apply?
// Yes. Group practices can apply, too. The Practice owner should designate a specific business representative to apply for the capital.

export const FAQData4: TFaqInfo[] = [
    {
        id: 14,
        pageId: 14,
        seq: 14,
        question: 'Q14. Why is this better than using a credit card?',
        answer: `
        Klarity Pay Later offers a flat <b>fee as low as 1%</b>, significantly lower than most credit card rates (~3%). It’s also automatically linked to your Klarity account, so no card processing or transfer delays.
        `,
    },
    {
        id: 15,
        pageId: 15,
        seq: 15,
        question: 'Q15. How fast can I access the funds?',
        answer: `
        You have access to the funding as little as 24 hours from application approval. Once you accept the offer, your Klarity invoice is financed on the spot—no waiting, no separate disbursement.
        `,
    },
    {
        id: 16,
        pageId: 16,
        seq: 16,
        question: 'Q16. Will using this affect my credit score?',
        answer: `
        Kanmon will perform a soft credit check. This check will not affect your credit score.
        `,
    },
    {
        id: 17,
        pageId: 17,
        seq: 17,
        question: 'Q17. Can group practices apply?',
        answer: `
        Yes. Group practices can apply, too. The Practice owner should designate a specific business representative to apply for the capital.
        `,
    },
];

// Q18. How do I track my repayment status?
// You can monitor your repayment progress in the Financials tab under your Provider Portal, showing:
// Remaining balance
// Fee schedule
// Upcoming payment date
// Q19. What happens if I fall behind on repayment?
// If you fall behind on repayment, Kanmon will send reminders by email and/or phone to help resolve the issue promptly. A $25 fee applies for each late payment, and a $35 fee applies for any returned payment due to insufficient funds in your account.
// Your Klarity account will remain fully active for patient care and scheduling—repayment delays will not affect your ability to see patients on Klarity.
// Q20. Can I cancel after applying?
// You may cancel before funds are applied to your Klarity invoice. Once disbursed, the advance cannot be canceled but can be repaid early without penalty.
// Q21. Will there be future Growth Capital programs?
// Yes. Klarity plans to expand this program with additional tiers (Growth Capital II in the coming months) supporting broader practice expenses like in-person visit set-up, staffing, and DEA compliance readiness.

export const FAQData5: TFaqInfo[] = [
    {
        id: 18,
        pageId: 18,
        seq: 18,
        question: 'Q18. How do I track my repayment status?',
        answer: `
        You can monitor your repayment progress in the <b>Financials tab</b> under your Provider Portal, showing:
        <ul>
            <li>Remaining balance</li>
            <li>Fee schedule</li>
            <li>Upcoming payment date</li>
        </ul>
        `,
    },
    {
        id: 19,
        pageId: 19,
        seq: 19,
        question: 'Q19. What happens if I fall behind on repayment?',
        answer: `
        If you fall behind on repayment, Kanmon will send reminders by email and/or phone to help resolve the issue promptly. A $25 fee applies for each late payment, and a $35 fee applies for any returned payment due to insufficient funds in your account.
        `,
    },
    {
        id: 20,
        pageId: 20,
        seq: 20,
        question: 'Q20. Can I cancel after applying?',
        answer: `
        You may cancel before funds are applied to your Klarity invoice. Once disbursed, the advance cannot be canceled but can be repaid early without penalty.
        `,
    },
    {
        id: 21,
        pageId: 21,
        seq: 21,
        question: 'Q21. Will there be future Growth Capital programs?',
        answer: `
        Yes. Klarity plans to expand this program with additional tiers (Growth Capital II in the coming months) supporting broader practice expenses like in-person visit set-up, staffing, and DEA compliance readiness.
        `,
    },
];

export const FAQData6: TFaqInfo[] = [
    {
        id: 22,
        pageId: 22,
        seq: 22,
        question: 'Q22. Who do I contact for questions or assistance?',
        answer: `
        <div>For general Klarity support — including questions related to your Klarity account, technical issues, general information or other Klarity products — please reach <b>Klarity Provider Support</b> at <a href="mailto: ${Email.klarity_provider_support}">${Email.klarity_provider_support}</a>.
        </div>
        <div>
If your inquiry is related to <b>Kanmon’s financial products</b> (for example, the status of your loan application, repayment schedule, available credit lines, or other account-specific details), please contact <b>Kanmon Support</b> directly:
</div>
        <p>
            <b>Email</b>: <a href="mailto:help@kanmon.com">help@kanmon.com</a>
        </p>
        <p>
            <b>Phone</b>: (619) 369-8151
        </p>
        <p>
            <b>Chat</b>: Through the Kanmon portal — click <b>Help</b> (top right corner) to start a chat with one of their agents
        </p>
         <p>
            <b>Hours</b>: 9 AM – 6 PM ET, Monday – Friday (excluding bank holidays)
        </p>
        `,
    },
];

const FAQ = () => {
    return (
        <div className={s.wrap}>
            <h2 className={s.title}>Frequently asked questions</h2>
            <h3>Overview</h3>
            <FrequencyQuestionSecion
                openAll={false}
                data={FAQData1}
                largerFontsize
            />
            <h3>Eligibility & Application</h3>
            <FrequencyQuestionSecion
                openAll={false}
                data={FAQData2}
                largerFontsize
            />
            <h3>Capital Terms & Repayment</h3>
            <FrequencyQuestionSecion
                openAll={false}
                data={FAQData3}
                largerFontsize
            />
            <h3>Benefits & Comparison</h3>
            <FrequencyQuestionSecion
                openAll={false}
                data={FAQData4}
                largerFontsize
            />
            <h3>Program Management</h3>
            <FrequencyQuestionSecion
                openAll={false}
                data={FAQData5}
                largerFontsize
            />
            <h3>Support</h3>
            <FrequencyQuestionSecion
                openAll={false}
                data={FAQData6}
                largerFontsize
            />
        </div>
    );
};

export default FAQ;
